module.exports = __webpack_public_path__ + "fi.svg?1439b028ee598d7534e48ee6d381fec8";